<template>
  <div id="cadastro">
    <div id="voltar">
      <h4>Cadastrar Atividade</h4>
      <button @click.prevent="$emit('fecharGestaoDeEquipe')">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <div class="form">
      <div id="campos-form-container">
        <div id="campos-form">
          <section id="esquerda">
            <h4>Integrantes Disponíveis</h4>
            <p class="subtitulo-form">Selecione os integrantes para a equipe</p>

            <div
              id="lista-membros-livres"
              v-if="membrosLivres && membrosLivres.length !== 0"
            >
              <label
                class="membro-livre"
                v-for="membro in membrosLivres"
                :key="membro.id"
                :class="{ 'membro-selecionado': verificarGrupo(membro) }"
              >
                <input
                  type="checkbox"
                  :checked="verificarGrupo(membro)"
                  @change="toggleMembro(membro)"
                />
                <span class="nome-membro">{{ membro.nome }}</span>
              </label>
            </div>

            <div
              id="lista-membros-livres-vazia"
              v-else
            >
              <h5>Todos membros do time da ação já estão alocados!</h5>
            </div>
          </section>

          <div class="divisor-vertical"></div>

          <section id="direita">
            <div class="cabecalho-direito">
              <h4>Equipe Atual</h4>
              <button
                id="excluir-grupo"
                type="button"
                class="btn-excluir-grupo"
                v-if="grupoIdAtividade != null"
                @click.prevent="excluirGrupoDeAtividade()"
              >
                Excluir equipe
              </button>
            </div>

            <div
              v-if="!grupoAtividade || grupoAtividade.length === 0"
              class="grupo-vazio"
            >
              <p>Nenhum grupo encontrado</p>
            </div>

            <div
              id="lista-membros-alocados"
              v-else
            >
              <div
                class="membro-alocado"
                v-for="(membroGrupo, index) in grupoAtividade"
                :key="index"
              >
                <div class="informacoes-membro">
                  <h5>
                    {{ formatarEnum(formatarNomeUsuario(membroGrupo.nome)) }}
                  </h5>
                  <p>
                    {{ verificarLidereanca(index) ? "Líder" : "Participante" }}
                  </p>
                </div>

                <div class="acoes-membro">
                  <button
                    class="btn-remover"
                    @click.prevent="removerMembroGrupo(index)"
                    type="button"
                  >
                    Remover
                  </button>
                  <button
                    :class="
                      verificarLidereanca(index)
                        ? 'btn-rebaixar'
                        : 'btn-promover'
                    "
                    @click.prevent="alterarFuncao(index)"
                    type="button"
                    :disabled="
                      verificarLidereanca(index) &&
                      verificarSeEhCoordenador(membroGrupo)
                    "
                  >
                    {{ verificarLidereanca(index) ? "Rebaixar" : "Promover" }}
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div id="modal-footer">
          <button
            id="btn-cancelar"
            type="button"
            @click="$emit('fecharGestaoDeEquipe')"
          >
            Cancelar
          </button>
          <button
            id="btn-salvar"
            type="button"
            :disabled="!novosMembros || novosMembros.length === 0"
            @click.prevent="adicionarMembros()"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>

    <Transition name="aviso-fade">
      <div
        v-if="aviso.visivel"
        class="aviso-overlay"
        @click.self="fecharAviso"
      >
        <div class="aviso-box">
          <div class="aviso-header">
            <span>AVISO</span>
            <button
              class="aviso-fechar"
              @click="fecharAviso"
            >
              ✕
            </button>
          </div>
          <div class="aviso-corpo">
            <div
              class="aviso-icone"
              :class="aviso.tipo"
            >
              <span v-if="aviso.tipo === 'sucesso'">✓</span>
              <span v-else>?</span>
            </div>
            <p class="aviso-mensagem">{{ aviso.mensagem }}</p>
            <div class="aviso-botoes">
              <button
                v-if="aviso.tipo !== 'sucesso'"
                class="aviso-btn aviso-btn-sim"
                @click="confirmarAviso"
              >
                SIM
              </button>
              <button
                class="aviso-btn aviso-btn-cancelar"
                @click="fecharAviso"
              >
                {{ aviso.tipo === "sucesso" ? "OK" : "Cancelar" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import atividadeService from "@/service/atividadeService";
import acaoService from "@/service/acaoService";
import { formatarEnum, formatarNomeUsuario } from "@/utils/FormatarEntradas";
import { useRoute } from "vue-router";
import grupoService from "@/service/grupoService";

const props = defineProps({
  acaoId: { type: String },
  atividadeId: { type: String },
});

const emit = defineEmits(["fecharGestaoDeEquipe"]);

const membrosLivres = ref([]);
const grupoAtividade = ref([]);
const grupoCadastrado = ref(false);
const novosMembros = ref([]);
const timeAcao = ref([]);
const carregando = ref(true);
const route = useRoute();
const grupoIdAtividade = ref(null);
const tituloAtividade = ref("");

const aviso = ref({
  visivel: false,
  mensagem: "",
  tipo: "confirmacao",
  resolve: null,
});

function mostrarConfirmacao(mensagem) {
  return new Promise((resolve) => {
    aviso.value = { visivel: true, mensagem, tipo: "confirmacao", resolve };
  });
}

function mostrarSucesso(mensagem) {
  return new Promise((resolve) => {
    aviso.value = { visivel: true, mensagem, tipo: "sucesso", resolve };
  });
}

function confirmarAviso() {
  const res = aviso.value.resolve;
  aviso.value.visivel = false;
  if (res) res(true);
}

function fecharAviso() {
  const res = aviso.value.resolve;
  aviso.value.visivel = false;
  if (res) res(false);
}

function verificarGrupo(membro) {
  if (!novosMembros.value) return false;
  return novosMembros.value.some((m) => m.id === membro.id);
}

function verificarLidereanca(index) {
  if (!grupoAtividade.value || !grupoAtividade.value[index]) return false;
  const membro = grupoAtividade.value[index];
  return membro.regras && Array.isArray(membro.regras)
    ? membro.regras.some(
        (regra) => regra.nome === "LIDER" || regra.nome === "COORDENADOR"
      )
    : false;
}

function verificarSeEhCoordenador(membro) {
  if (!membro || !membro.regras || !Array.isArray(membro.regras)) {
    return false;
  }
  return membro.regras.some((regra) => regra.nome === "COORDENADOR");
}

function toggleMembro(membro) {
  if (verificarGrupo(membro)) {
    removerMembro(membro);
  } else {
    adicionarMembro(membro);
  }
}

function adicionarMembro(membro) {
  if (!novosMembros.value) novosMembros.value = [];
  if (!verificarGrupo(membro)) {
    novosMembros.value.push(membro);
  }
}

function removerMembro(membro) {
  if (!novosMembros.value) return;
  novosMembros.value = novosMembros.value.filter((m) => m.id !== membro.id);
}

async function removerMembroGrupo(index) {
  if (!grupoAtividade.value || !grupoAtividade.value[index]) return;
  const membro = grupoAtividade.value[index];
  const confirmacao = await mostrarConfirmacao(
    `Tem certeza de que deseja remover\n<${membro.nome}> da equipe?`
  );
  if (!confirmacao) return;
  const remover = [{ emailMembros: membro.email }];
  try {
    await atividadeService.removerMembroGrupo(props.atividadeId, remover);
    await carregarGrupo();
    await getEquipeAcao();
  } catch (error) {
    console.error("Erro ao remover membro:", error);
  }
}

async function carregarTituloAtividade() {
  try {
    const response = await atividadeService.getAtividadeId(props.atividadeId);
    if (response?.status === 200) {
      tituloAtividade.value =
        response.data?.titulo ?? response.data?.nome ?? "";
    } else {
      tituloAtividade.value = "";
    }
  } catch (error) {
    console.error("Erro ao carregar título da atividade:", error);
    tituloAtividade.value = "";
  }
}

async function excluirGrupoDeAtividade() {
  if (!grupoCadastrado.value) return;
  const confirmacao = await mostrarConfirmacao(
    `Tem certeza de que deseja excluir\na equipe formada?`
  );
  if (!confirmacao) return;
  try {
    await grupoService.deletGrupoAtividade(grupoIdAtividade.value);
    grupoAtividade.value = [];
    grupoCadastrado.value = false;
    grupoIdAtividade.value = null;
    await getEquipeAcao();
  } catch (error) {
    console.error("Erro ao excluir grupo:", error);
  }
}

async function getEquipeAcao() {
  try {
    const acaoId = props.acaoId || route.params.id;
    if (!acaoId) return;
    const equipeAcaoData = await acaoService.getMembrosTime(acaoId);
    timeAcao.value = equipeAcaoData;

    if (
      grupoCadastrado.value &&
      grupoAtividade.value &&
      grupoAtividade.value.length > 0
    ) {
      membrosLivres.value = equipeAcaoData.filter((membroAcao) => {
        return !grupoAtividade.value.some(
          (membroGrupo) => membroGrupo.email === membroAcao.email
        );
      });
    } else {
      membrosLivres.value = [...equipeAcaoData];
    }

    membrosLivres.value.sort((a, b) =>
      (a.nome?.toLowerCase() || "").localeCompare(b.nome?.toLowerCase() || "")
    );
  } catch (error) {
    console.error("Erro ao carregar equipe da ação:", error);
    membrosLivres.value = [];
  }
}

async function adicionarMembros() {
  if (!novosMembros.value || novosMembros.value.length === 0) return;
  const membrosValidos = novosMembros.value.filter(
    (membro) => membro && membro.email && membro.id
  );
  if (membrosValidos.length === 0) return;

  const confirmacao = await mostrarConfirmacao(
    `Tem certeza que deseja adicionar\n<${membrosValidos.length}> membro(s) à equipe?`
  );
  if (!confirmacao) return;

  const payload = membrosValidos
    .map((membro) => ({
      emailMembros: membro.email,
      funcao: verificarSeEhCoordenador(membro) ? "LIDER" : "PARTICIPANTE",
    }))
    .filter((item) => item.emailMembros != null);

  try {
    if (grupoCadastrado.value) {
      await atividadeService.adicionarMembroGrupo(props.atividadeId, payload);
    } else {
      await atividadeService.cadastrarGrupoAtividade(
        props.atividadeId,
        payload
      );
    }
    await carregarGrupo();
    await getEquipeAcao();
    novosMembros.value = [];
  } catch (error) {
    console.error("Erro ao adicionar membros:", error);
  }
}

async function carregarGrupo() {
  try {
    const response = await atividadeService.getGrupoAtividade(
      props.atividadeId
    );
    grupoIdAtividade.value = response.grupoId;

    let membros = [];

    if (response.Membros) {
      membros = response.Membros;

      // Garantir que coordenadores apareçam como líderes
      membros = membros.map((membro) => {
        const ehCoordenador = verificarSeEhCoordenador(membro);
        if (
          ehCoordenador &&
          (!membro.regras || !membro.regras.some((r) => r.nome === "LIDER"))
        ) {
          // Se for coordenador mas não tem regra LIDER, adicionar
          if (!membro.regras) membro.regras = [];
          membro.regras.push({ nome: "LIDER" });
        }
        return membro;
      });
    }

    if (membros.length > 0) {
      grupoAtividade.value = membros;
      grupoCadastrado.value = true;
    } else {
      grupoAtividade.value = [];
      grupoCadastrado.value = false;
    }
  } catch (error) {
    console.error("Erro ao carregar grupo:", error);
    if (error.response?.status === 404) {
      grupoAtividade.value = [];
      grupoCadastrado.value = false;
      grupoIdAtividade.value = null;
    }
  }
}

async function alterarFuncao(index) {
  if (!grupoAtividade.value || !grupoAtividade.value[index]) return;
  const nomeMembro = grupoAtividade.value[index].nome;
  const membroGrupo = grupoAtividade.value[index];
  const dadosMembro = timeAcao.value.find((m) => m.nome === nomeMembro);
  if (!dadosMembro) return;

  try {
    if (verificarLidereanca(index)) {
      // Verificar se é coordenador antes de permitir rebaixamento
      if (verificarSeEhCoordenador(membroGrupo)) {
        await mostrarSucesso(
          `Não é possível rebaixar <${nomeMembro}>.\nCoordenadores não podem ser rebaixados de líderes.`
        );
        return;
      }

      const confirmacao = await mostrarConfirmacao(
        `Tem certeza de que deseja rebaixar\n<${nomeMembro}> a participante?`
      );
      if (confirmacao) {
        await atividadeService.rebaixarMembroEquipe(
          props.atividadeId,
          dadosMembro
        );
        await carregarGrupo();
      }
    } else {
      const confirmacao = await mostrarConfirmacao(
        `Tem certeza de que deseja promover\n<${nomeMembro}> a líder?`
      );
      if (confirmacao) {
        await atividadeService.promoverMembroEquipe(
          props.atividadeId,
          dadosMembro
        );
        await carregarGrupo();
        await mostrarSucesso(
          `<${nomeMembro}> foi definido como\nlíder com sucesso!`
        );
      }
    }
  } catch (error) {
    console.error("Erro ao alterar função:", error);
  }
}

onMounted(async () => {
  document.body.classList.add("modal-aberto");

  try {
    await carregarGrupo();
    await getEquipeAcao();
    await carregarTituloAtividade();
  } catch (error) {
    console.error("Erro ao inicializar componente:", error);
  } finally {
    carregando.value = false;
  }
});

onBeforeUnmount(() => {
  document.body.classList.remove("modal-aberto");
});
</script>

<style scoped>
#modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

#modal-container {
  background: white;
  border-radius: 12px;
  width: 90vw;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

#modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: var(--azul-escuro, #1a1a2e);
  padding: 14px 24px;
}

#modal-header h3 {
  margin: 0;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

#btn-fechar {
  position: absolute;
  right: 16px;
  background: transparent;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 2px 8px;
  line-height: 1;
  transition: opacity 0.2s;
}

#btn-fechar:hover {
  opacity: 0.7;
}

#double-section-forms {
  display: flex;
  width: 100%;
  overflow: hidden;
  min-height: 0;
}

.lado-esquerdo {
  flex: 1;
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.lado-direito {
  flex: 1;
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.divisor-vertical {
  width: 1px;
  background-color: #e0e0e0;
  margin: 16px 0;
  flex-shrink: 0;
}

.lado-esquerdo h4,
.lado-direito h4 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 4px 0;
}

.subtitulo-form {
  font-size: 0.83rem;
  color: #888;
  margin: 0 0 16px 0;
}

.cabecalho-direito {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.btn-excluir-grupo {
  background: transparent;
  border: 1.5px solid var(--roxo-claro, #6f319e);
  color: #555;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-excluir-grupo:hover {
  border-color: #e53935;
  color: #e53935;
}

#lista-membros-livres {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  overflow-y: auto;
  padding-right: 6px;
}

#lista-membros-livres::-webkit-scrollbar {
  width: 5px;
}
#lista-membros-livres::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
#lista-membros-livres::-webkit-scrollbar-thumb {
  background: var(--roxo-claro, #6f319e);
  border-radius: 10px;
}

.membro-livre {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1.5px solid #ccc;
  border-radius: 25px;
  padding: 10px 18px;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;
  user-select: none;
}

.membro-livre:hover {
  border-color: var(--roxo-claro, #6f319e);
  background-color: #faf5ff;
}

.membro-livre input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--roxo-claro, #6f319e);
  cursor: pointer;
  flex-shrink: 0;
}

.membro-livre .nome-membro {
  font-size: 0.95rem;
  color: #333;
  flex: 1;
}

.membro-selecionado {
  border-color: #4a90d9;
  background-color: #edf4fc;
}

#lista-membros-livres-vazia {
  text-align: center;
  padding: 2rem 1rem;
  color: #999;
}

#lista-membros-livres-vazia h5 {
  color: var(--roxo-claro, #6f319e);
  font-size: 0.9rem;
}

#lista-membros-alocados {
  flex: 1;
  overflow-y: auto;
  padding-right: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
}

#lista-membros-alocados::-webkit-scrollbar {
  width: 5px;
}
#lista-membros-alocados::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
#lista-membros-alocados::-webkit-scrollbar-thumb {
  background: var(--roxo-claro, #6f319e);
  border-radius: 10px;
}

.membro-alocado {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 12px 16px;
  gap: 12px;
}

.informacoes-membro {
  flex: 1;
}

.informacoes-membro h5 {
  margin: 0 0 2px 0;
  color: #1a1a2e;
  font-weight: 700;
  font-size: 0.9rem;
}

.informacoes-membro p {
  margin: 0;
  color: #555;
  font-size: 0.8rem;
}

.acoes-membro {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: stretch;
}

.btn-remover {
  background-color: #e53935;
  color: white;
  border: none;
  padding: 5px 0;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  width: 86px;
  text-align: center;
}

.btn-remover:hover {
  opacity: 0.85;
}

.btn-promover {
  background-color: var(--roxo-claro, #6f319e);
  color: white;
  border: none;
  padding: 5px 0;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  width: 86px;
  text-align: center;
}

.btn-promover:hover {
  opacity: 0.85;
}

.btn-rebaixar {
  background-color: white;
  color: var(--roxo-claro, #6f319e);
  border: 1.5px solid var(--roxo-claro, #6f319e);
  padding: 5px 0;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 86px;
  text-align: center;
}

.btn-rebaixar:hover:not(:disabled) {
  background-color: #f5edfb;
}

.btn-rebaixar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f0f0f0;
  color: #999;
  border-color: #ccc;
}

.grupo-vazio {
  flex: 1;
  text-align: center;
  padding: 2rem 1rem;
  color: #999;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

#modal-footer {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  padding: 16px 24px 24px;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;
}

#btn-cancelar {
  background: transparent;
  border: 1.5px solid #ccc;
  color: #555;
  padding: 9px 28px;
  border-radius: 25px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
}

#btn-cancelar:hover {
  border-color: #999;
  color: #333;
}

#btn-salvar {
  background-color: var(--roxo-claro, #6f319e);
  border: none;
  color: white;
  padding: 9px 28px;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

#btn-salvar:hover:not(:disabled) {
  background-color: var(--roxo-escuro1, #5a2680);
}
#btn-salvar:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.aviso-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.aviso-box {
  background: white;
  border-radius: 14px;
  width: 320px;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.3);
}

.aviso-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--azul-escuro, #1a1a2e);
  padding: 10px 16px;
}

.aviso-header span {
  color: white;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.aviso-fechar {
  background: transparent;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  padding: 0 4px;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.aviso-fechar:hover {
  opacity: 1;
}

.aviso-corpo {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 24px 24px;
  gap: 16px;
}

.aviso-icone {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 700;
  flex-shrink: 0;
}

.aviso-icone.confirmacao {
  background-color: var(--roxo-claro, #6f319e);
  color: white;
}

.aviso-icone.sucesso {
  background-color: #4caf50;
  color: white;
}

.aviso-mensagem {
  margin: 0;
  text-align: center;
  font-size: 0.92rem;
  color: #333;
  line-height: 1.5;
  white-space: pre-line;
}

.aviso-botoes {
  display: flex;
  gap: 10px;
  justify-content: center;
  width: 100%;
}

.aviso-btn {
  padding: 8px 28px;
  border-radius: 25px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.aviso-btn-sim {
  background-color: var(--roxo-claro, #6f319e);
  color: white;
}

.aviso-btn-sim:hover {
  background-color: var(--roxo-escuro1, #5a2680);
}

.aviso-btn-cancelar {
  background: transparent;
  border: 1.5px solid #ccc;
  color: #555;
}

.aviso-btn-cancelar:hover {
  border-color: #999;
  color: #333;
}

.aviso-fade-enter-active {
  transition: opacity 0.2s ease;
}
.aviso-fade-leave-active {
  transition: opacity 0.15s ease;
}
.aviso-fade-enter-from,
.aviso-fade-leave-to {
  opacity: 0;
}
.aviso-fade-enter-active .aviso-box {
  transition: transform 0.2s ease;
}
.aviso-fade-enter-from .aviso-box {
  transform: scale(0.9);
}

@media (max-width: 768px) {
  #double-section-forms {
    flex-direction: column;
    overflow-y: auto;
  }

  .divisor-vertical {
    width: calc(100% - 48px);
    height: 1px;
    margin: 0 24px;
  }

  .lado-esquerdo,
  .lado-direito {
    max-height: none;
    flex: none;
  }
}
</style>
